import {View} from 'MWC';
import tpl from '../templates/TransferTableNew.jsx';
import React from 'react';
import {canUseDOM} from '../../../../helpers/canUseDOM.js';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            width: canUseDOM ? window.innerWidth : 1366
        };
    }

    updateWidth = () => {
        this.setState({width: window.innerWidth});
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }
}
